export default __webpack_public_path__ + "9496dc6b7bdcd1325b3d241ffab55419.png";